import { createAction, createReducer } from '@reduxjs/toolkit';

const REPORT = createAction('error/report');
const CLEAR = createAction('error/clear');

export const actions = {
  REPORT,
  CLEAR,
};

function reportHandler(_prev, action) {
  return action.payload;
}

function clearHandler(_prev) {
  return null;
}

const reducer = createReducer(null, {
  [REPORT]: reportHandler,
  [CLEAR]: clearHandler,
});

export default reducer;
